export default __webpack_public_path__ + "static/media/ic-call-us.d837d78f.svg";